export default "__VITE_ASSET__D1ZvMPL5__"